import classNames from 'classnames';
import React, { ReactElement } from 'react';
import { ICustomButtonGroupProps } from '../../Carousel/Buttons/ButtonGroup';
import { CustomArrow } from '../CustomArrow/CustomArrow';
import styles from './CarouselButtonGroup.module.scss';

export function CarouselButtonGroup({ next, previous, className }: ICustomButtonGroupProps): ReactElement {
  return (
    <div className={classNames(styles.wrapper, "carousel-button-group", className)}>
      <CustomArrow direction='left' onClick={() => previous()} />
      <CustomArrow direction='right' onClick={() => next()} />
    </div>
  );
}
